import { Amount } from "@/components";
import { colors } from "@/styles/colors";
import { Icon } from "@/ui";
import { FunctionComponent, ReactElement } from "react";
import styles from "./Saving.module.scss";
import { ISavingProps } from "./types";

export const Saving: FunctionComponent<ISavingProps> = (
  props: ISavingProps
): ReactElement<ISavingProps> => {
  const { saving, ...restProps } = props;

  return (
    <div {...restProps}>
      <div className="blockLine">
        <h2>{saving.name}</h2>
      </div>
      <div
        className="fullCard bankCard marginBottom"
        style={{
          backgroundColor: saving.color,
        }}
      >
        <div className="smallCard marginBottom">
          <Icon
            backgroundColor="rgb(255 255 255 / 15%)"
            className={styles.iconDefault}
            color={colors.palette.white}
            icon={saving.icon}
            size={32}
          />
          <div className="cardContent">
            <Amount
              className="cardContentValue"
              currency={saving.currency}
              value={saving.balance}
            />
            <span className="cardContentLabel">{saving.name}</span>
          </div>
        </div>
        {false && (
          <ul className="btnGroupHorizontal">
            <li className="btnGroupHorizontalLi">
              <a
                href="#"
                className="transparentBtn"
                onClick={() => console.log("twoLevelModal(addIncome);")}
              >
                Доход
              </a>
            </li>
            <li className="btnGroupHorizontalLi">
              <a
                href="#"
                className="transparentBtn"
                onClick={() => console.log("twoLevelModal(addExpense);")}
              >
                Расход
              </a>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};
